import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import middlewarePipeline from '../plugins/middleware-pipeline'

import AuthMiddleware from './middleware/auth'
import RedirectMiddleware from './middleware/redirect'
import LocationMiddleware from './middleware/location'
import BusinessMiddleware from './middleware/business'
// import ManagerCheckMiddleware from './middleware/manager'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: {
        middleware: [RedirectMiddleware]
      },
      component: () => import('../views/Login.vue')
    },
    {
      path: '/business',
      name: 'Business',
      meta: {
        middleware: [BusinessMiddleware]
      },
      component: () => import('../views/Business.vue')
    },
    {
      path: '/location',
      name: 'Location',
      meta: {
        middleware: [LocationMiddleware]
      },
      component: () => import('../views/Location.vue')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/Dashboard.vue')
    },
    {
      path: '/archive',
      name: 'Archive',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/Archive.vue')
    },
    {
      path: '/public-forms',
      name: 'Public Forms',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/PublicForms.vue')
    },
    {
      path: '/new-submission',
      name: 'CreateNewSubmission',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/CreateNewSubmission.vue')
    },
    {
      path: '/submission/:id',
      name: 'Submission',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/Submission.vue')
    },
    {
      path: '/archive/:id',
      name: 'ArchiveSubmission',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/Submission.vue')
    },
    {
      path: '/public/:id',
      name: 'PublicSubmissions',
      meta: {
        middleware: [AuthMiddleware]
      },
      component: () => import('../views/Submission.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware || to.meta.middleware.length <= 0) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
